export type TrackingParameterErrorAd = {
  ad_id: string;
  account_id: string;
  name: string;
  source: string;
  status: string;
};

export type TrackingParameterErrorAccount = {
  account_id: string;
  csid: string | undefined;
  name: string;
  source: string;
  organisation_id: string;
};

enum TrackingErrorLevel {
  AD = "ad",
  ADSET = "adset",
  CAMPAIGN = "campaign",
  ACCOUNT = "account",
}

export type TrackingParameterError = {
  id: number;
  content: string;
  source: string;
  status: string;
  errors: string[];
  last_checked_at: string;
  ad: TrackingParameterErrorAd;
  account: TrackingParameterErrorAccount;
  level: TrackingErrorLevel | null;
};

export type TrackingParameterErrorsResult = {
  items: TrackingParameterError[];
  totalCount: number;
  countByAdProvider: Record<string, number>;
};

export type UseTrackingParameterErrorsOptions = {
  by_accounts?: Array<{ account_id: string }>;
  sources?: string[];
  limit?: number;
  offset?: number;
  enabled?: boolean;
};
